module.exports = __webpack_public_path__ + "media/country_flags/tw-da4cdf0c.png";